export interface PricingData {
    variant: string,
    price: string,
    description: string
}

export const pricingData: PricingData[] = [
    {
        variant: "(Streaming) BGM",
        price: "150-200",
        description: "1-3 minutes max."
    },

    {
        variant: "Original song + vocals",
        price: "300",
        description: "~3 minutes"
    },

    {
        variant: "Cover + vocal mixing",
        price: "250",
        description: "~3 minutes"
    },

    {
        variant: "Cover + instrumental (no vocal)",
        price: "200",
        description: "~3 minutes"
    },

];